import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom"; 
// css
import styles from "./onboard.module.scss";
 

const OnboardLayout = () => {
  const [sidebar, setSidebar] = useState();
  const location = useLocation();

  return (
    <> 
      <div  >
        <main
          className={`${styles.MainBody} MainBody position-relative`}
        >

          <Outlet />
        </main>
      </div >
    </>
  );
};
export default OnboardLayout;
